PJQ.views.projects.SignProjectNDAModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Sign-Project-NDA'),
		maxWidth: '800px'
	},
	events: {
		'click .btn-decline-nda': 'decline',
		'click .btn-sign-nda': 'sign',
		'change .input-nda-agree': 'agreeChanged'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
	},
	agreeChanged: function () {
		this.$('.btn-sign-nda').prop('disabled', !this.$('.input-nda-agree').prop('checked'));
	},
	decline: function () {
		new PJQ.Loader(this.$('.modal-body'));
		PJQ.app.session.project.updateResponse(PJQ.constants.projectContacts.bidStatus.DECLINE, _.bind(function () {
			this.close();
			PJQ.notifications.notify.successNotify({
				message: 'Your response has been submitted'
			});
			PJQ.app.router.signInNavigate();
		}, this));
	},
	sign: function () {
		let isValid = true,
			$companyName = this.$('.input-nda-company-name'),
			companyName = $companyName.val();
		PJQ.helpers.inputHelpers.setInputError($companyName, true);
		if (_.size(companyName) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($companyName, false);
		}

		let $contactName = this.$('.input-nda-contact-name'),
			contactName = $contactName.val();
		PJQ.helpers.inputHelpers.setInputError($contactName, true);
		if (_.size(contactName) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($contactName, false);
		}

		let $title = this.$('.input-nda-title'),
			title = $title.val();
		PJQ.helpers.inputHelpers.setInputError($title, true);
		if (_.size(title) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($title, false);
		}

		let $email = this.$('.input-nda-email'),
			email = $email.val();
		PJQ.helpers.inputHelpers.setInputError($email, true);
		if (_.size(email) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($email, false);
		}

		let $phone = this.$('.input-nda-phone'),
			phone = $phone.val();
		PJQ.helpers.inputHelpers.setInputError($phone, true);
		if (_.size(phone) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($phone, false);
		}

		let $error = this.$('.nda-error');
		if (!isValid) {
			$error.html('All required fields must be filled out before signing');
			return;
		}

		let isAgreed = this.$('.input-nda-agree').prop('checked');
		if (!isAgreed) {
			$error.html('You must agree to the non-disclosure before signing');
			return;
		}
		else {
			$error.empty();
		}

		this.$('.btn-decline-nda').prop('disabled', true);
		new PJQ.Loader(this.$('.btn-sign-nda'), {
			loadingText: "Signing..."
		});
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.model.id
				},
				{
					endpoint: 'nda',
					value: this.model.nda.get('ndaId')
				},
				{
					endpoint: 'sign'
				}
			]),
			data: {
				companyName: companyName,
				contactName: contactName,
				title: title,
				email: email,
				phone: phone
			}
		}).post().done(_.bind(function () {
			this.model.isFetched = false;
			PJQ.modules.projectWall.initProjectNavigator(this.model.id, this.options.activeItem ? this.options.activeItem : "dashboard", this.options.viewOptions ? this.options.viewOptions : null);
			this.removeModal();
		}, this));
	}
});

PJQ.views.projects.EditProjectNDAModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Edit-Project-NDA'),
		maxWidth: '800px'
	},
	events: {
		'change .cb-override': 'overrideChanged',
		'click .btn-delete-nda': 'deleteClicked',
		'click .btn-cancel-nda': 'cancelClicked',
		'click .btn-save-nda': 'saveClicked'
	},
	beforeModalCreated: function () {
		if (this.options.project != null) {
			PJQ.app.session.fetchNDAs(_.bind(function (ndas) {
				this.ndas = ndas;
				this.options.project.fetchNDA(_.bind(function (nda) {
					this.model = nda;
					this.render();
				}, this));
			}, this));
		}
	},
	renderData: function () {
		return {
			model: this.model,
			project: this.options.project,
			ndas: this.ndas
		};
	},
	afterRender: function () {
		if (this.model != null && this.options.project != null) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-nda'),
				hideDisabled: true,
				defaultValue: this.model.id,
				onChange: _.bind(function (value) {
					this.useNDA(this.ndas.get(value));
					this.render();
				}, this)
			});
		}
	},
	useNDA: function (nda) {
		this.model.set({
			ndaId: nda ? nda.id : null,
			name: nda ? nda.get('name') : '',
			ndaText: nda ? nda.get('ndaText') : ''
		});
	},
	overrideChanged: function () {
		let override = this.$('.cb-override').prop('checked');
		if (override) {
			this.model.set({
				ndaId: null,
				name: ''
			});
		}
		else {
			this.useNDA(this.ndas.findWhere({isDefault: true}));
		}
		this.render();
	},
	deleteClicked: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Delete NDA",
			body: "Are you sure you want to delete this project NDA?",
			onDelete: _.bind(function () {
				if (this.model.id > 0) {
					this.model.destroy();
				}

				this.removeModal();
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
			}, this)
		});
	},
	cancelClicked: function () {
		this.removeModal();
		if (this.options.onCancel) {
			this.options.onCancel(this.model);
		}
	},
	saveClicked: function () {
		if (this.options.project != null) {
			let ndaText = this.$('.textarea-nda-text').val(),
				gNda = this.ndas.get(this.model.id);
			if (gNda == null && _.size(ndaText) === 0) {
				new PJQ.views.modals.SaveDontSave({
					header: "NDA Terms Empty",
					body: "You have not entered any NDA agreement terms.  If you save this, the NDA will be disabled for this project.  Are you sure you want to save?",
					isShowDontSaveButton: false,
					onSave: _.bind(function () {
						this.save();
					}, this)
				});
			}
			else {
				this.save();
			}
		}
		else {
			this.save();
		}
	},
	save: function () {
		let ndaText = this.$('.textarea-nda-text').val(),
			isDefault,
			name,
			saveNda;
		if (this.options.project != null) {
			name = this.model.get('name');
			isDefault = false;
			saveNda = this.ndas.get(this.model.id) != null || _.size(ndaText) > 0;
			this.options.project.set('hasNDA', saveNda, {
				silent: true
			});
		}
		else {
			name = this.$('.input-nda-name').val();
			isDefault = this.$('.cb-default').prop('checked');
			saveNda = true;
		}
		if (saveNda) {
			this.model.save({
				name: name,
				ndaText: ndaText,
				isDefault: isDefault
			}, {
				success: _.bind(function () {
					if (this.options.onSave) {
						this.options.onSave(this.model);
					}
					this.removeModal();
					PJQ.notifications.notify.successNotify({
						message: "NDA updated successfully"
					});
				}, this)
			});
		}
		else {
			if (this.options.project != null) {
				this.model.destroy();
			}
			this.removeModal();
		}
	}
});
